import React, { useEffect } from 'react'
import CovidMain from '../components/covid-testing/CovidMain'
import CovidTests from '../components/covid-testing/CovidTests'
import CovidTestingSolutions from '../components/covid-testing/CovidTestingSolutions'
import CovidAntigenTesting from '../components/covid-testing/CovidAntigenTesting'
import CovidTestingInChicago from '../components/covid-testing/CovidTestingInChicago'
import CovidRapidTesting from '../components/covid-testing/CovidRapidTesting'
import CovidTestingProcess from '../components/covid-testing/CovidTestingProcess'
import CovidWhyChooseUs from '../components/covid-testing/CovidWhyChooseUs'
import CovidFaq from '../components/covid-testing/CovidFaq'
import TopHeader from '../layout/TopHeader'
import MainHeader from '../layout/MainHeader'
import Footer from '../layout/Footer'
import CopyRight from '../layout/CopyRight'
import MainResHeader from '../layout/MainResHeader'
import { Helmet, HelmetProvider } from 'react-helmet-async'

const CovidTestingPage = () => {

  useEffect(()=>{
    window.scrollTo(0,0)
  },[])

  return (
    <div style={{ overflow:'hidden'}}>
    <HelmetProvider>
      <Helmet prioritizeSeoTags>
      <title>Rapid Covid &amp; RT PCR Test In Chicago | United Lab Care</title>
      <meta name="description" content="United Lab Care provides fast and reliable Covid and PCR test in Chicago with accurate results. Schedule your appointment today. (800) 442-1663" />
	<link rel="canonical" href="https://unitedlabcare.com/covid-and-rt-pcr-test-in-chicago-il/" />
	<meta property="og:locale" content="en_US" />
	<meta property="og:type" content="article" />
	<meta property="og:title" content="Rapid Covid &amp; RT PCR Test In Chicago | United Lab Care" />
	<meta property="og:description" content="United Lab Care provides fast and reliable Covid and PCR test in Chicago with accurate results. Schedule your appointment today. (800) 442-1663" />
	<meta property="og:url" content="https://unitedlabcare.com/covid-and-rt-pcr-test-in-chicago-il/" />
	<meta property="og:site_name" content="United Lab Care" />
	<meta property="article:modified_time" content="2023-03-29T13:08:04+00:00" />
	<meta property="og:image" content="https://unitedlabcare.com/wp-content/uploads/2023/03/Covid-Testing-img1-v1.png" />
	<meta name="twitter:card" content="summary_large_image" />
	<meta name="twitter:label1" content="Est. reading time" />
	<meta name="twitter:data1" content="13 minutes" />
      </Helmet>
    </HelmetProvider>
        <TopHeader/>
        {/* <MainHeader/> */}
        <MainResHeader/>
       
        <CovidMain/>
        <CovidTests/>
        <CovidTestingSolutions/>
        <CovidAntigenTesting/>
        <CovidTestingInChicago/>
        <CovidRapidTesting/>
        <CovidTestingProcess/>
        <CovidWhyChooseUs/>
        <CovidFaq/>

        <Footer/>
        <CopyRight/>
    </div>
  )
}

export default CovidTestingPage